export default "__VITE_ASSET__ad2bc1eb__"